export default "__VITE_ASSET__f44e5fc7__"